<template>
  <div class="app-container">
    <el-form
      ref="postForm"
      :model="postForm"
      :rules="rules"
      class="form-container"
      label-width="180px"
      label-position="left"
    >
      <el-form-item label="旧密码" prop="old_pass">
        <el-input
          v-model="postForm.old_pass"
          autocomplete="off"
          placeholder="请输入旧密码"
          type="password"
          class="input-form"
        />
      </el-form-item>

      <el-form-item label="新密码" prop="new_pass">
        <el-input
          v-model="postForm.new_pass"
          autocomplete="off"
          placeholder="请输入新密码"
          type="password"
          class="input-form"
        />
        <p style="font-size: 12px;text-align: left;margin: 5px 0 0px;line-height: 1.5;letter-spacing: 1px;">必须包含数字,英文,特殊符号[!@#$%^&*(),], 长度8-20位</p>
      </el-form-item>

      <el-form-item label="确认密码" prop="new_pass_confirmation">
        <el-input
          v-model="postForm.new_pass_confirmation"
          placeholder="请确认新密码"
          type="password"
          class="input-form"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width: 200px"
          @click="submitForm('postForm')"
        >
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { resetPassword } from '@/api/user'
import { RES_SUCCESS_CODE } from '@/constances/server'
import _ from 'lodash'
export default {
  name: 'Profile',
  data() {
    var validatenewPd = (rule, value, callback) => {
      // const reg = /^[0-9A-Za-z]{6,20}$/
      // if (!reg.test(value)) {
      //   const falg = eval(
      //     `/^[0-9A-Za-z]{${value.length},${value.length}}$/`
      //   ).test(value)
      //   if (!falg) {
      //     return callback(new Error('密码只能输入数字或字母'))
      //   } else if (value.length < 6) {
      //     callback(new Error('密码不能少于6位'))
      //   } else if (value.length > 20) {
      //     callback(new Error('密码不能超过20位'))
      //   } else {
      //   }
      // } else {
      //   callback()
      // }
      if (!/[0-9]+/.test(value)) {
        return callback(new Error('密码必须包含数字或字母'))
      }
      if (!/[A-Za-z]+/.test(value)) {
        return callback(new Error('密码必须包含数字或字母'))
      }
      if (!/[!@#$%^&*(),]+/.test(value)) {
        return callback(new Error('密码必须包含特殊符号!@#$%^&*(),'))
      }
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else if (value.length > 20) {
        callback(new Error('密码不能超过20位'))
      } else {
        if (this.postForm.new_pass_confirmation !== '') {
          this.$refs.postForm.validateField('new_pass_confirmation')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.postForm.new_pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      rules: {
        old_pass: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        new_pass: [{ required: true, message: '请输入新密码', trigger: 'blur' },
          {
            required: true,
            validator: validatenewPd,
            trigger: ['blur', 'change']
          }
        ],
        new_pass_confirmation: [{ required: true, message: '请确认新密码', trigger: 'blur' }, { validator: validatePass2, trigger: 'blur' }]
      },
      postForm: Object.assign({}, {
        new_pass: '',
        new_pass_confirmation: '',
        old_pass: '',
        id: ''
      })
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'avatar',
      'roles',
      'userInfo'
    ])
  },
  created() {
    this.postForm.id = this.userInfo.id
  },
  methods: {
    submitForm() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          const postForm = _.cloneDeep(this.postForm)
          resetPassword(postForm).then(res => {
            if (res.code === RES_SUCCESS_CODE) {
              this.$notify({
                title: res.message,
                type: 'success',
                onClose: () => {
                  this.$router.go(-1)
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.input-form {
  width: 300px;
}
</style>
